import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-toggle",
  templateUrl: "./toggle.component.html",
  styleUrls: [ "./toggle.component.scss" ]
})
export class ToggleComponent implements OnInit {
  @Input() size: string;
  @Input() disabled = false;
  @Input() initialState: boolean;
  @Output() changed: EventEmitter<any> = new EventEmitter();

  toggleState: boolean;
  falseLabel = this.translate.instant("No");
  trueLabel = this.translate.instant("Yes");

  private id: string;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.id = this.generateId();
    if (this.initialState !== undefined || this.initialState !== null) {
      this.toggleState = this.initialState;
    } else {
      this.toggleState = false;
    }
  }

  generateId(): string {
    return `toggle-${Date.now()}${Math.floor(Math.random() * 1000)}`;
  }

  changeToggleState($event) {
    if (!this.disabled) {
      this.toggleState = $event.target.checked;
      this.changed.emit($event.target.checked);
    }
  }
}
